"use client";

import { useAuth, type AuthUser } from "../providers/AuthProvider";

export type CurrentUser = AuthUser;

/**
 * Hook that returns the current authenticated user.
 * Now just a thin wrapper around useAuth().
 */
export function useCurrentUser() {
  const { ready, authenticated, user } = useAuth();

  return {
    user,
    loading: !ready,
    error: null as string | null,
    refetch: () => {},
  };
}
